import { Observable } from 'rxjs';
import { Injectable } from "@angular/core";
import { MatPaginator } from "@angular/material/paginator";
import { MatSort } from "@angular/material/sort";
import { Router } from "@angular/router";
import { MatTableHelper, SimpleDialogComponent, ButtonColor, SimpleDialogData, CommonActionKey, hasValue, setQueryVarsFromPaginator } from "common";
import { BrokerUsersQueryParams, BrokerUserData } from "../../domain/models/broker-user.model";
import { MatDialog } from "@angular/material/dialog";

@Injectable()
export class BrokerUserListFacade {
  constructor(
    private router: Router,
    private dialog: MatDialog) { }

  showBrokerUserDisableDialog(brokerUser: BrokerUserData): Observable<string> {
    const dialogData: SimpleDialogData = {
      title: "Disable user",
      body: `Do you want to disable user ${brokerUser.firstName} ${brokerUser.lastName}?`,
      actions: [
        { label: "CANCEL", buttonColor: ButtonColor.Default, actionKey: CommonActionKey.Cancel },
        { label: "CONFIRM", buttonColor: ButtonColor.Primary, actionKey: CommonActionKey.Confirm },
      ],
    };
    return SimpleDialogComponent.show(this.dialog, dialogData);
  }

  filter(paginator?: MatPaginator, sort?: MatSort) {
    const query = new BrokerUsersQueryParams();

    query.skip = undefined;

    if (hasValue(paginator)) {
      setQueryVarsFromPaginator(query, paginator);
    }

    if (hasValue(sort)) {
      query.sort = MatTableHelper.getSort(query.sort ?? "", sort);
    }

    void this.router.navigate([], {
      queryParams: query,
    });
  }
}
